import SM from "../../images/SM.png";
import Modal from "../Modules/Modal";
import { useState } from "react";

const SMmsg = () => {
  const [showModal, setShowModal] = useState(false);
  return (
    <div className="px-md-5 bg-color-w py-5 px-4">
      <div className="d-flex flex-row">
        <div className="d-flex align-items-center justify-content-center pe-3">
          <img src={SM} alt="Mr. Saeed Mohammadi" style={{ width: "130px" }} />
        </div>
        <div className="d-flex align-items-center justify-content-center px-2">
          <h3 className="dk-bold">
            Together We Have Reached the Third Generation of Digikala
          </h3>
        </div>
      </div>

      <h5 className="my-3 dk-semi-bold">
        Saeed Mohammadi, Cofounder and Chairman of Digikala
      </h5>
      <p className="my-3">
        What is known as Digikala today, is resulted after over 15 years of ups
        and downs; Starting from ...
      </p>
      <h6
        className="dk-link  dk-bold"
        onClick={() => {
          setShowModal(true);
        }}
      >
        {"Read More >"}
      </h6>
      <Modal showModal={showModal} setShowModal={setShowModal}>
        <div>
          <div className="d-flex flex-row">
            <div className="d-flex align-items-center justify-content-center pe-3">
              <img
                src={SM}
                alt="Mr. Saeed Mohammadi"
                style={{ width: "130px" }}
              />
            </div>
            <div className="d-flex align-items-center justify-content-center px-2">
              <h3 className="dk-bold">
                Together We Have Reached the Third Generation of Digikala
              </h3>
            </div>
          </div>

          <h5 className="my-3  dk-semi-bold">
            Saeed Mohammadi, Cofounder and Chairman of Digikala
          </h5>
          <p>
            What is known as Digikala today, is resulted after over 15 years of
            ups and downs; Starting from the days of being a small online store
            when we used to handle all the process of supply, sales and delivery
            alone, to the current days that we provide services nationwide for
            all Iranian people in participation with tens of thousands of
            sellers, thousands of brands, technology and logistics corporations
            and of course, about ten thousand talented and enthusiastic
            colleagues. We had to get out of the previous formats in order to
            create the best customer experience. The decision on providing the
            marketplace platform was an exciting challenge for us. Collaboration
            with a variety of other Iranian sellers including large
            manufacturers and numerous local businesses, allowed us to provide
            an impressive increase in the diversity of our products; and at the
            same time, the enhanced capacities in other sections like
            technology, content, commerce and of course, operations and
            logistics, made Digikala the primary reference for merchandise
            search and purchase.
          </p>
          <p>
            Together we have reached the third generation of Digikala, and
            developed an almost perfect ecosystem of digital economy. This
            synergy has always motivated us to establish more transparency,
            value creation and positive impacts on the digital economy. What
            could be more pleasing than making the social equity come true by
            providing everyone with equal access to online commerce? We will
            continue energetically towards our mission and welcome new
            challenges. Talents which made the Digikala, are precious resources
            for us and the whole Iran. We deeply believe that the development of
            Iran is in the hands of bright-minded and hopeful young talents.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default SMmsg;
